<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage kiwoomView"
  >
    <header-area />

    <div class="worksView topPosition" :class="readyAction ? 'ready-action' : ''">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">KOREA Stock Market No.1 <br />Kiwoom Securities</div>
            <div class="workSlogan mobile">KOREA Stock Market No.1 <br />Kiwoom Securities</div>
            <div class="workTopDay">
              <p>키움증권 웹서비스 리뉴얼</p>
              <ul>
                <li>PC / Mobile web</li>
                <li>2021.06.01</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://www.kiwoom.com/h/main" target="_blank" class="siteAddr"
                >https://www.kiwoom.com</a
              >
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/kiwoom"
                    title="주식 초보도 주식 고수도 함께 보는 간편 투자 플랫폼"
                    hashtags="플립커뮤니케이션즈,키움증권"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/kiwoom"
                    title="주식 초보도 주식 고수도 함께 보는 간편 투자 플랫폼"
                    hashtags="플립커뮤니케이션즈,키움증권"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt"
            ><marquee-text :duration="15"
              >KOREA Stock Market No.1 Kiwoom Securities&nbsp;&nbsp;</marquee-text
            ></span
          >
          <img class="web" src="@/assets/images/works_view/kiwoom/img_kiwoom_visual.png" alt="" />
          <img class="mobile" src="@/assets/images/works_view/kiwoom/kiwoom_visual_m.png" alt="" />
        </div>
      </div>

      <div class="contsBox">
        <div class="topInfo">
          키움증권은 지난 2005년부터 개인 주식시장 점유율 1위를 지키고 있습니다. 특히 2020년에는
          국내외 주식시장을 강타한 '동·서학개미운동'에 힘입어 개인 투자자 유입이 크게 늘며, 한
          해에만 333만 개의 신규 계좌를 개설하고 역대 최고치인 9,690억 원의 영업이익을 돌파했습니다.
          키움증권은 이러한 신규 투자자의 대거 유입에 발맞춰 지난 10년간 유지해온 홈페이지를 비롯해
          대대적인 웹서비스 개편을 진행했습니다.
        </div>

        <div
          class="kiwoomCount"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <ul>
            <li>
              <span class="countW">국내주식 일 약정 금액</span
              ><em class="countN">20,100,000,000,000</em><span class="progress" />
              <img
                class="web"
                src="@/assets/images/works_view/kiwoom/kiwoom_count_bar1.png"
                alt=""
              />
              <img
                class="mobile"
                src="@/assets/images/works_view/kiwoom/kiwoom_count_bar_m.png"
                alt=""
              />
            </li>
            <li>
              <span class="countW">역대 최고치 영업이익</span><em class="countN">969,000,000,000</em
              ><span class="progress" />
              <img
                class="web"
                src="@/assets/images/works_view/kiwoom/kiwoom_count_bar2.png"
                alt=""
              />
              <img
                class="mobile"
                src="@/assets/images/works_view/kiwoom/kiwoom_count_bar_m.png"
                alt=""
              />
            </li>
            <li>
              <span class="countW">신규 개설 계좌 수</span><em class="countN">3,330,000</em
              ><span class="progress" />
              <img
                class="web"
                src="@/assets/images/works_view/kiwoom/kiwoom_count_bar3.png"
                alt=""
              />
              <img
                class="mobile"
                src="@/assets/images/works_view/kiwoom/kiwoom_count_bar_m.png"
                alt=""
              />
            </li>
            <li>
              <span class="countW">전체 주식시장 점유율 1위</span><em class="countN">16</em
              ><span class="progress" />
              <img
                class="web"
                src="@/assets/images/works_view/kiwoom/kiwoom_count_bar4.png"
                alt=""
              />
              <img
                class="mobile"
                src="@/assets/images/works_view/kiwoom/kiwoom_count_bar_m.png"
                alt=""
              />
            </li>
          </ul>
        </div>
      </div>
    </div>

    <kinesis-container event="scroll">
      <div class="wideConts">
        <!-- Goal -->
        <div class="kiwoomConcept">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="tit"><span class="line">Goal</span></div>
              <p class="txt web">
                주식 브로커리지 1위를 넘어 종합 증권사로 도약하기 위해<br />투자자들에게 키움증권의
                다양한 금융 상품에 대한 정보를 간편하게 제공하고자 했습니다.
              </p>
              <p class="txt mobile">
                주식 브로커리지 1위를 넘어 종합 증권사로 도약하기 위해 투자자들에게 키움증권의
                다양한 금융 상품에 대한 정보를 간편하게 제공하고자 했습니다.
              </p>
            </div>
            <div class="kiwoomRound">
              <lottie :options="kiwoomBgOpt01" />
              <span class="dvice"
                ><img src="@/assets/images/works_view/kiwoom/img_kiwoom_round.png" alt=""
              /></span>
            </div>
            <div class="kiwoomMain">
              <span class="txtOpc">Korea</span>
              <span class="txtOpc">Stock Market No.1</span>
              <span class="txtOpc">Kiwoom Securities</span>
              <div
                class="sec1Slider swiper-container"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <img src="@/assets/images/works_view/kiwoom/kiwoom_main_slide1.png" alt="" />
                  </div>
                  <div class="swiper-slide">
                    <img src="@/assets/images/works_view/kiwoom/kiwoom_main_slide2.png" alt="" />
                  </div>
                  <div class="swiper-slide">
                    <img src="@/assets/images/works_view/kiwoom/kiwoom_main_slide3.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="kiwoomSub">
              <ul class="subPageMove left">
                <li>
                  <img src="@/assets/images/works_view/kiwoom/kiwoom_main_left1.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/kiwoom/kiwoom_main_left2.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/kiwoom/kiwoom_main_left3.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/kiwoom/kiwoom_main_left1.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/kiwoom/kiwoom_main_left2.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/kiwoom/kiwoom_main_left3.png" alt="" />
                </li>
              </ul>
              <ul class="subPageMove right">
                <li>
                  <img src="@/assets/images/works_view/kiwoom/kiwoom_main_right1.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/kiwoom/kiwoom_main_right2.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/kiwoom/kiwoom_main_right1.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/kiwoom/kiwoom_main_right2.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/kiwoom/kiwoom_main_right1.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/kiwoom/kiwoom_main_right2.png" alt="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- //Goal -->
        <!-- Point 1 -->
        <div class="kiwoomConcept">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="tit"><span class="line">Point 1</span></div>
              <div class="titT">투자 과정에 따른 정보 제공!</div>
              <p class="txt">
                주식은 사회적 이슈와 트렌드에 투자하는 상품으로 이러한 흐름에 대한 정보가 투자에
                있어 가장 중요한 요소입니다.<br />
                상품 검색에서 투자로 이어지는 모든 과정에서 고객들의 편의를 고려해 키움증권 대표
                홈페이지를 포함한 6개 채널의 별도 가이드라인을 수립하고,각 채널에 산재해 있던 정보를
                통합해 투자자들이 원하는 정보를 더 쉽고 빠르게 찾을 수 있도록 개선했습니다.
              </p>
            </div>
            <div class="kiwoomCnt">
              <ul>
                <li>
                  <img
                    class="web"
                    src="@/assets/images/works_view/kiwoom/img_kiwoom_cnt1.png"
                    alt=""
                  />
                  <img
                    class="mobile"
                    src="@/assets/images/works_view/kiwoom/img_kiwoom_cnt1_m.png"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    class="web"
                    src="@/assets/images/works_view/kiwoom/img_kiwoom_cnt2.png"
                    alt=""
                  />
                  <img
                    class="mobile"
                    src="@/assets/images/works_view/kiwoom/img_kiwoom_cnt2_m.png"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    class="web"
                    src="@/assets/images/works_view/kiwoom/img_kiwoom_cnt3.png"
                    alt=""
                  />
                  <img
                    class="mobile"
                    src="@/assets/images/works_view/kiwoom/img_kiwoom_cnt3_m.png"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    class="web"
                    src="@/assets/images/works_view/kiwoom/img_kiwoom_cnt4.png"
                    alt=""
                  />
                  <img
                    class="mobile"
                    src="@/assets/images/works_view/kiwoom/img_kiwoom_cnt4_m.png"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    class="web"
                    src="@/assets/images/works_view/kiwoom/img_kiwoom_cnt5.png"
                    alt=""
                  />
                  <img
                    class="mobile"
                    src="@/assets/images/works_view/kiwoom/img_kiwoom_cnt5_m.png"
                    alt=""
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- //Point 1 -->
        <!-- Point 2 -->
        <div class="kiwoomConcept type2">
          <div class="worksView">
            <div
              class="txtWrap right"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="tit"><span class="line">Point 2</span></div>
              <div class="titT web">한곳에서 관리하는 금융상품!</div>
              <div class="titT mobile">한곳에서 관리하는<br />금융상품!</div>
              <p class="txt web">
                자산관리 페이지를 통합해 대표 홈페이지에서 자산 현황을 조회하고 관리할 수 있으며,<br />‘한눈에
                보기’에서 투자 현황, 계좌 정보, 통합 잔고 등의 정보를 한 번에 확인할 수 있습니다.<br />또한
                기존에는 로그인해야만 볼 수 있었던 상품 정보를 전체 메뉴로 개편함으로써<br />기존
                투자자들은 물론 잠재 고객들도 키움증권의 금융 상품을 쉽게 둘러볼 수 있습니다.
              </p>
              <p class="txt mobile">
                자산관리 페이지를 통합해 대표 홈페이지에서 자산 현황을 조회하고 관리할 수 있으며,
                ‘한눈에 보기’에서 투자 현황, 계좌 정보, 통합 잔고 등의 정보를 한 번에 확인할 수
                있습니다. 또한 기존에는 로그인해야만 볼 수 있었던 상품 정보를 전체 메뉴로
                개편함으로써 기존 투자자들은 물론 잠재 고객들도 키움증권의 금융 상품을 쉽게 둘러볼
                수 있습니다.
              </p>
            </div>
            <div class="kiwoomGrape">
              <lottie :options="kiwoomBgOpt02" />
            </div>
            <div
              class="homepageRoliing"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="rollingArea">
                <div>
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_account.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //Point 2 -->
        <!-- Point 3 -->
        <div class="kiwoomConcept type3">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="tit"><span class="line">Point 3</span></div>
              <div class="titT">쉽게 찾고 빠르게 비교하는 스마트 검색!</div>
              <p class="txt web">
                투자자들이 원하는 상품을 손쉽게 검색하고 비교할 수 있도록 검색 UI를 개선했습니다.<br />기존에는
                상품명 리스트를 통해 볼 수 있었던 개별 상품 정보는<br />종목코드/상품명을 입력하면
                자동완성과 초성 검색을 통해 빠르게 찾을 수 있습니다.<br />이와 함께 장바구니, 상품
                비교, 관심 상품 등의 기능을 탑재하여 여러 상품의 정보를 비교할 수 있게 구현했습니다.
              </p>
              <p class="txt mobile">
                투자자들이 원하는 상품을 손쉽게 검색하고 비교할 수 있도록 검색 UI를 개선했습니다.
                기존에는 상품명 리스트를 통해 볼 수 있었던 개별 상품 정보는 종목코드/상품명을
                입력하면 자동완성과 초성 검색을 통해 빠르게 찾을 수 있습니다. 이와 함께 장바구니,
                상품 비교, 관심 상품 등의 기능을 탑재하여 여러 상품의 정보를 비교할 수 있게
                구현했습니다.
              </p>
              <div class="kiwoomSearch">
                <span class="title">상품 검색</span>
                <div class="box">
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_search1.png" alt="" />
                </div>
              </div>
            </div>
            <div
              class="kiwoomSmart"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="left">
                <span class="title">상품 담기</span>
                <div class="box">
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_search2.png" alt="" />
                  <div class="sBox">
                    <img src="@/assets/images/works_view/kiwoom/img_kiwoom_search2_1.png" alt="" />
                  </div>
                </div>
              </div>
              <div class="right">
                <span class="title">상품 비교</span>
                <div class="box">
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_search3.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //Point 3 -->
        <!-- Point 4 -->
        <div class="kiwoomConcept">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="tit"><span class="line">Point 4</span></div>
              <div class="titT web">필요한 정보만 쏙쏙 모은 투자 가이드</div>
              <div class="titT mobile">필요한 정보만 쏙쏙 모은 <br />투자 가이드</div>
              <p class="txt web">
                상품별로 상품안내, 거래방법 등 필수 정보와 상품 이해에 도움이 되는<br />매체 활용법,
                수익구조, 용어안내 등의 세부 정보를 함께 제공합니다.<br />특히 ‘시작하기’에서는 계좌
                개설과 거래가 가능한 매체로 바로 연결되도록<br />QR코드와 앱 다운로드 링크를
                제공하여 UX의 연결성을 높였습니다.
              </p>
              <p class="txt mobile">
                상품별로 상품안내, 거래방법 등 필수 정보와 상품 이해에 도움이 되는 매체 활용법,
                수익구조, 용어안내 등의 세부 정보를 함께 제공합니다. 특히 ‘시작하기’에서는 계좌
                개설과 거래가 가능한 매체로 바로 연결되도록 QR코드와 앱 다운로드 링크를 제공하여
                UX의 연결성을 높였습니다.
              </p>
            </div>

            <div class="sec2Slider swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <span class="slideTit">국내주식 시작하기</span>
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_slide1_1.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <span class="slideTit">해외주식 시작하기</span>
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_slide1_2.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <span class="slideTit">금융상품 시작하기</span>
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_slide1_3.png" alt="" />
                </div>
              </div>
            </div>
            <div class="txtWrap">
              <p class="txt web">
                키움증권의 무료 투자 교육 사이트인 ‘하우투스탁’을 디바이스 호환성을 높인 반응형
                웹으로 개편하고 대표 홈페이지와 연동했습니다.<br />또한 ‘투자정보 한눈에 보기’에서는
                투자에 도움이 되는 정보를 한데 모아 실시간으로 확인할 수 있습니다.<br />국가별
                주가지수와 금리, 환율, 원유 등 파생 상품과 관련된 시세 정보를 실시간으로 제공합니다.
              </p>
              <p class="txt mobile">
                키움증권의 무료 투자 교육 사이트인 ‘하우투스탁’을 디바이스 호환성을 높인 반응형
                웹으로 개편하고 대표 홈페이지와 연동했습니다. 또한 ‘투자정보 한눈에 보기’에서는
                투자에 도움이 되는 정보를 한데 모아 실시간으로 확인할 수 있습니다. 국가별 주가지수와
                금리, 환율, 원유 등 파생 상품과 관련된 시세 정보를 실시간으로 제공합니다.
              </p>
            </div>
            <div class="sec3Slider swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_slide2_1.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_slide2_2.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_slide2_3.png" alt="" />
                </div>
              </div>
            </div>
            <div class="sec4Slider swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_slide3_1.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_slide3_2.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/kiwoom/img_kiwoom_slide3_3.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //Point 4 -->
        <!-- Design Element -->
        <div class="kiwoomConcept type4">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="tit"><span class="line">Design Element</span></div>
              <p class="txt web">
                아이콘 스타일, 컬러, 폰트는 고객이 서비스를 이용할 때 자연스레 접하는 요소입니다.
                <br />의미를 직관적으로 정의하는 동시에 ‘키움다움’을 전달할 수 있도록 구성했습니다.
              </p>
              <p class="txt mobile">
                아이콘 스타일, 컬러, 폰트는 고객이 서비스를 이용할 때 자연스레 접하는 요소입니다.
                <br />의미를 직관적으로 정의하는 동시에 ‘키움다움’을 전달할 수 있도록 구성했습니다.
              </p>
            </div>
            <div
              class="kiwoomDesign"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="box">
                <img
                  class="web"
                  src="@/assets/images/works_view/kiwoom/img_kiwoom_design1.png"
                  alt=""
                />
                <img
                  class="mobile"
                  src="@/assets/images/works_view/kiwoom/img_kiwoom_design1_m.png"
                  alt=""
                />
              </div>
              <div class="box">
                <img
                  class="web"
                  src="@/assets/images/works_view/kiwoom/img_kiwoom_design2.png"
                  alt=""
                />
                <img
                  class="mobile"
                  src="@/assets/images/works_view/kiwoom/img_kiwoom_design2_m.png"
                  alt=""
                />
              </div>
              <div class="box">
                <img
                  class="web"
                  src="@/assets/images/works_view/kiwoom/img_kiwoom_design3.png"
                  alt=""
                />
                <img
                  class="mobile"
                  src="@/assets/images/works_view/kiwoom/img_kiwoom_design3_m.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="kiwoomLogo">
            <img src="@/assets/images/works_view/kiwoom/kiwoom_logo.png" alt="" />
          </div>
        </div>
        <!-- //Design Element -->
      </div>
    </kinesis-container>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-TitleistA' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">타이틀리스트 어패럴 웹사이트 개편</strong>
          <strong class="mobile">타이틀리스트 어패럴<br />웹사이트 개편</strong>
        </div>

        <div class="engBg titleistAEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Lottie from "vue-lottie";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";
import { TweenLite } from "gsap/all";
import kiwoombg01 from "@/assets/json/motion/kiwoombg01.json";
import kiwoombg02 from "@/assets/json/motion/kiwoombg02.json";
Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "Main",
  /* head: {
    title: {
      inner: '키움증권'
    }
  }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText,
    Lottie
  },
  data() {
    return {
      meta: {
        siteName: "키움증권 홈페이지 | 플립커뮤니케이션즈",
        title: "키움증권 홈페이지",
        desc:
          "키움증권은  대표 홈페이지를 포함한 6개 채널의 별도 가이드라인을 수립하고, 정보 통합으로 투자자가 쉽고 빠르게 원하는 정보를 찾을수 있도록 개선했습니다. 자산관리 페이지 통합, 스마트 검색UI 개선, 투자 가이드 제공 등 고객 편의 중심 서비스를 구현했습니다.",
        keywords:
          "키움증권, 한국 주식 시장, 주식 브로커리지, 종합 증권사, 개인 주식시장, 금융 상품 정보, 자산 관리, 투자자 정보 제공, 스마트 검색 기능, 투자 가이드, 주식 거래 방법, 투자 교육, 반응형 웹, 실시간 시세 정보, 키움다움",
        url: "https://www.pulip.com/works/kiwoom",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      W: 0,
      icoInter: null,
      icoVal: 0,
      scorePlay01: { score: 0, complete: true },
      scorePlay02: { score: 0, complete: true },
      scorePlay03: { score: 0, complete: true },
      scorePlay04: { score: 0, complete: true },
      kiwoomBgOpt01: { animationData: kiwoombg01, loop: true, autoplay: true },
      kiwoomBgOpt02: { animationData: kiwoombg02, loop: true, autoplay: true }
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }
  },
  methods: {
    // vuejs Bicint

    scoreObserveActive01(isVisible) {
      let scoreEnd = bigInt(20000000000000);
      if (isVisible) {
        if (this.scorePlay01.complete) {
          this.scorePlay01.complete = false;
          TweenLite.to(this.scorePlay01, 1.5, { score: scoreEnd, roundProps: "score" });
        }
      } else {
        this.scorePlay01.score = 0;
        this.scorePlay01.complete = true;
      }
    },
    scoreObserveActive02(isVisible) {
      let scoreEnd = bigInt(969000000000);
      if (isVisible) {
        if (this.scorePlay02.complete) {
          this.scorePlay02.complete = false;
          TweenLite.to(this.scorePlay02, 1.5, { score: scoreEnd, roundProps: "score" });
        }
      } else {
        this.scorePlay02.score = 0;
        this.scorePlay02.complete = true;
      }
    },
    scoreObserveActive03(isVisible) {
      const scoreEnd = 3330000;
      if (isVisible) {
        if (this.scorePlay03.complete) {
          this.scorePlay03.complete = false;
          TweenLite.to(this.scorePlay03, 1.5, { score: scoreEnd, roundProps: "score" });
        }
      } else {
        this.scorePlay03.score = 0;
        this.scorePlay03.complete = true;
      }
    },
    scoreObserveActive04(isVisible) {
      const scoreEnd = 16;
      if (isVisible) {
        if (this.scorePlay04.complete) {
          this.scorePlay04.complete = false;
          TweenLite.to(this.scorePlay04, 1.5, { score: scoreEnd, roundProps: "score" });
        }
      } else {
        this.scorePlay04.score = 0;
        this.scorePlay04.complete = true;
      }
    },
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/kiwoom").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    visibilityChanged(isVisible, entry) {
      // this.isVisible = isVisible
      console.log(entry);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    this.sec1Slider1.destroy();
    this.sec1Slider2.destroy();
    this.sec1Slider3.destroy();
    this.sec1Slider4.destroy();
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.icoInter);
  },
  mounted() {
    this.sec1Slider1 = new window.Swiper(".sec1Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      loop: true,
      spaceBetween: 60,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    });

    this.sec1Slider2 = new window.Swiper(".sec2Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      effect: "fade",
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    });

    this.sec1Slider3 = new window.Swiper(".sec3Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      loop: true,
      spaceBetween: 60,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    });

    this.sec1Slider4 = new window.Swiper(".sec4Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      loop: true,
      spaceBetween: 60,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    });
  }
};
</script>
